export default __webpack_public_path__ + "static/media/CHS-logo.7f308776.svg";